const MintNow = function (props) {
  return (
    <div className="mint-now">
      <h3>Mint now</h3>
      <h2 className="calculate">
        0.1 ETH <span>/ piece</span>
      </h2>
      <h3>#1 of 6942 minted (6942 max)</h3>
    </div>
  );
};

export default MintNow;
